import authApi from '@/api/authApi'
import { queryKeys } from '@/constant/common'
import { ChangeUserProfilePayload } from '@/types/user'
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'

async function editUserProfile(
  payload: ChangeUserProfilePayload,
): Promise<void> {
  await authApi.changeProfile(payload)
}

function useUpdateUserProfile(): UseMutateFunction<
  void,
  unknown,
  ChangeUserProfilePayload,
  unknown
> {
  const queryClient = useQueryClient()

  const { mutate } = useMutation(
    (payload: ChangeUserProfilePayload) => editUserProfile(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.user])
        queryClient.invalidateQueries([queryKeys.interface])
        window.location.reload()
      },
      onError: (error) => {
        // toast.error(error)
      },
    },
  )

  return mutate
}

export default useUpdateUserProfile
